package com.ai.mitra.di


import com.ai.mitra.data.network.GeminiService
import com.ai.mitra.data.network.GeminiServiceImp
import org.koin.dsl.module

val geminiServiceModule = module {
    single<GeminiService> { GeminiServiceImp(get()) }
}
